import LoginCorporationInfo from './module/LoginCorporationInfo';
import HeaderNotification from './module/HeaderNotification';
import HeaderSetting from './module/HeaderSetting';
import SwitchSideBar from './module/SwitchSideBar';
import PeriodSelector from './module/PeriodSelector';
import PeriodSelectorSeparate from './module/PeriodSelectorSeparate';
import ExpandArticle from './module/ExpandArticle';
import SwitchInputDataTable from './module/SwitchInputDataTable';
import ToolDialog from './module/ToolDialog';
import SettingAccount from './module/SettingAccount';
import SettingGourmetSite from './module/SettingGourmetSite';
import SettingInvoice from './module/SettingInvoice';
import SettingPayment from './module/SettingPayment';
import ChangePassword from './module/ChangePassword';
import NewsDialog from './module/NewsDialog';
import FirstSettingDialog from './module/FirstSettingDialog';
import LoginErrorDialog from './module/LoginErrorDialog';

import datepicker from './module/datepicker';

window.onload = () => {
  const loginCorporationInfo = new LoginCorporationInfo();
  const headerNotification = new HeaderNotification();
  const headerSetting = new HeaderSetting();
  const switchSideBar = new SwitchSideBar();
  const periodSelector = new PeriodSelector();
  const periodSelectorSeparate = new PeriodSelectorSeparate();
  const expandArticle = new ExpandArticle();
  const switchInputDataTable = new SwitchInputDataTable();
  const toolDialog = new ToolDialog();
  const settingAccount = new SettingAccount();
  const settingGourmetSite = new SettingGourmetSite();
  const settingInvoice = new SettingInvoice();
  const settingPayment = new SettingPayment();
  const changePassword = new ChangePassword();
  const newsDialog = new NewsDialog();
  const firstSettingDialog = new FirstSettingDialog();
  const loginErrorDialog = new LoginErrorDialog();
  loginCorporationInfo.start();
  headerNotification.start();
  headerSetting.start();
  switchSideBar.start();
  periodSelector.start();
  periodSelectorSeparate.start();
  expandArticle.start();
  switchInputDataTable.start();
  toolDialog.start();
  settingAccount.start();
  settingGourmetSite.start();
  settingInvoice.start();
  settingPayment.start();
  changePassword.start();
  newsDialog.start();
  firstSettingDialog.start();
  loginErrorDialog.start();
  datepicker();
};



// WEBPACK FOOTER //
// ./src/js/main.js